import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  TextField,
  TextFieldProps,
  Typography,
} from '@material-ui/core';
import React from 'react';
import {
  EFormTags,
  IFormSection,
  IOption,
} from '../../shared/interfaces/form-interfaces';
import { IErrors } from '../../utils/getValidationErrors';
import { NumberFormatCustom } from '../NumberFormatCustom';
import { CellphoneInput } from './CellphoneInput';
import useStyles from './style';

type IFormData = {
  [key: string]: any;
};

type IProps = {
  form: IFormSection[];
  onChange: (e: React.ChangeEvent<any>) => void;
  data: IFormData;
  errors: IErrors;
};

type ICustomInputProps = {
  tag: EFormTags;
  options: IOption[];
};

const CustomInput: React.FC<
  ICustomInputProps & TextFieldProps & SelectProps
> = props => {
  const { tag } = props;
  if (tag === EFormTags.textField) {
    return <TextField {...props} />;
  }

  if (tag === EFormTags.whatsapp) {
    return (
      <TextField
        {...props}
        InputProps={{
          inputComponent: CellphoneInput as any,
        }}
      />
    );
  }

  if (tag === EFormTags.currency) {
    return (
      <TextField
        {...props}
        InputProps={{
          inputComponent: NumberFormatCustom as any,
        }}
      />
    );
  }

  if (tag === EFormTags.select) {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id={`label_${props.name}_id`}>{props.label}</InputLabel>
        <Select labelId={`label_${props.name}_id`} {...props}>
          {props.options.map(option => (
            <MenuItem value={option.value} key={option.value + props.name}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return <></>;
};

const CustomForm: React.FC<IProps> = ({ onChange, data, form, errors }) => {
  const classes = useStyles();

  return (
    <>
      {form.map(formSection => (
        <Grid
          key={formSection.title + formSection.id}
          container
          style={{ maxWidth: '100%', margin: 0 }}
          spacing={2}
        >
          {formSection.title && (
            <Grid item xs={12} style={{ marginTop: '16px' }}>
              <Typography variant="h5">{formSection.title}</Typography>
            </Grid>
          )}
          {formSection.items.map(formItem => (
            <Grid
              key={formSection.title + formSection.id + formItem.name}
              item
              xs={formItem.xs || 12}
              sm={formItem.sm || 12}
              md={formItem.md || 12}
              lg={formItem.lg || 12}
            >
              <CustomInput
                key={formSection.title + formSection.id + formItem.name}
                value={data[formItem.name]}
                tag={formItem.tag}
                name={formItem.name}
                type={formItem.type || 'text'}
                label={formItem.label}
                onChange={onChange}
                helperText={errors[formItem.name]}
                error={!!errors[formItem.name]}
                fullWidth
                variant="outlined"
                className={classes.input}
                options={formItem.options || []}
              />
            </Grid>
          ))}
        </Grid>
      ))}
    </>
  );
};

export default CustomForm;
